import { FC } from "react";
import { useFormContext } from "react-hook-form";

import { AISettingsFormData } from "../types/form-inputs.ts";
import { ErrorMessage } from "./catalyst/ErrorMessage.tsx";
import { Field } from "./catalyst/Field.tsx";
import { Textarea } from "./catalyst/Textarea.tsx";
import InputFieldGroup from "./inputs/InputFieldGroup.tsx";
import SelectFieldGroup from "./inputs/SelectFieldGroup.tsx";
import SliderInputGroup from "./inputs/SliderInputGroup.tsx";

export const QueryActionAISettings: FC = () => {
  const methods = useFormContext<AISettingsFormData>();
  const {
    control,
    formState: { errors },
    register,
  } = methods;

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <h3 className="text-sm font-medium text-gray-300">
          Performance Settings
        </h3>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <SelectFieldGroup<AISettingsFormData>
              errors={errors}
              fieldName="confidenceLevel"
              label="Confidence Level"
              options={[
                { label: "Low", value: "low" },
                { label: "Medium", value: "medium" },
                { label: "High", value: "high" },
              ]}
              register={register}
              rules={{ required: "Enter a confidence level" }}
            />
          </div>

          <div>
            <InputFieldGroup<AISettingsFormData>
              errors={errors}
              fieldName="maxRetries"
              label="Max Retries"
              placeHolder="3"
              register={register}
              rules={{
                max: { message: "Max retries is 10", value: 10 },
                min: { message: "Must be a positive number", value: 0 },
                required: "Please enter a max retries",
                valueAsNumber: true,
              }}
              type="number"
            />
          </div>

          <div>
            <InputFieldGroup<AISettingsFormData>
              errors={errors}
              fieldName="timeoutSeconds"
              label="Timeout (seconds)"
              placeHolder="3"
              register={register}
              rules={{
                max: { message: "Max timeout is 600", value: 600 },
                min: { message: "Must be a positive number", value: 0 },
                required: "Please enter a timeout in seconds",
                valueAsNumber: true,
              }}
              type="number"
            />
          </div>

          <div>
            <SliderInputGroup<AISettingsFormData>
              control={control}
              defaultValue={1}
              errors={errors}
              fieldName="costWeight"
              label="Cost Weight"
            />
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <h3 className="text-sm font-medium text-gray-300">Execution Rules</h3>
      </div>

      <div className="space-y-4">
        <h3 className="text-sm font-medium text-gray-300">Preconditions</h3>

        <div>
          <Field>
            <Textarea
              id="description"
              placeholder="e.g., Only run this if IP is from internal subnet"
              {...register("preconditions", {
                required: "Please enter preconditions",
              })}
            />
            {errors.preconditions && (
              <ErrorMessage>{errors.preconditions.message}</ErrorMessage>
            )}
          </Field>
        </div>
      </div>
    </div>
  );
};
